import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IDataSourceBackendParam, IPrescriptionToBeRenewedInfosResponse, RENEW_TIMING } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { PrescriptionService } from "src/app/providers/prescription.service";

export class PrescriptionsToBeRenewedDataSource extends MatTableDataSourceBackendExtended<IPrescriptionToBeRenewedInfosResponse> {
  public rawData$ = this.dataSubject.asObservable();
  constructor(private prescriptionService: PrescriptionService) {
    super();
  }

  public data(
    params: IDataSourceBackendParam & { timing: RENEW_TIMING; services?: string }
  ): Observable<IPrescriptionToBeRenewedInfosResponse[]> {
    return this.prescriptionService.listPrescriptionsToBeRenewedInfos(params);
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
          Use this, the day we decide to make the page implements AbstractBackendTablePage
          */
    return of(0);
  }
}
